import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { APIResponse } from "src/app/core/models/api-response";
import { environment } from "src/environments/environment";
import { IInboundChannel } from "../models/order.model";

@Injectable({
  providedIn: 'root',
})
export class InboundChannelService {

  constructor(private http: HttpClient) { }

  /** GET /v1/orders/inbound-channel — forwarding address + 7-day email-order count. */
  getInboundChannel(): Observable<IInboundChannel> {
    return this.http
      .get<APIResponse<IInboundChannel>>(`${environment.BASE_URL_API}orders/inbound-channel`)
      .pipe(
        map((res) => {
          const channel = res.object;
          if (!channel) {
            throw new Error('Missing inbound channel in response');
          }
          return channel;
        })
      );
  }
}
